import type { Tagged } from "@-/com.npmjs.type-fest";
import type { HanziScript } from "@-/dev.improve.haniverse.lib.actor.types";
import { createGate } from "@-/dev.improve.haniverse.lib.gate";
import { useTraditionalCharactersEnabled } from "@-/dev.improve.haniverse.lib.posthog";
import { useActorUser } from "@-/dev.improve.haniverse.lib.user";

export type SlideHanziScriptTableGate = Tagged<
  {
    /** The learner's current script, whose column the table tints. */
    script: HanziScript;
  },
  "SlideHanziScriptTableGate"
>;

/**
 * The table only exists while Traditional characters are offered (the `traditionalCharacters`
 * flag); without it the toggle slide explains that Han teaches Simplified, and there is nothing to
 * compare. `null` is that designed hidden state.
 */
export function useSlideHanziScriptTableGate(): SlideHanziScriptTableGate | null {
  const traditionalCharactersEnabled = useTraditionalCharactersEnabled();
  const { hanziScript: script } = useActorUser();
  return traditionalCharactersEnabled ? createGate<SlideHanziScriptTableGate>({ script }) : null;
}
